const getLogging = () => {
  if (typeof window !== 'undefined') {
    return window.location.hostname.match(/(dev.thrifty.co)|(web.stage.digital)/g) !== null
  }
  return false
}

export const loggingEnabled = getLogging()
